import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { Loading } from '../../../../loading'

const DeliveryDetailsContent = dynamic(
  async () =>
    import('./ProductPageNowDialogDeliveryDetailsContent/ProductPageNowDialogDeliveryDetailsContent').then(
      (mod) => mod.ProductPageNowDialogDeliveryDetailsContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)

export const ProductPageNowDialogDynamicContent: FC = () => {
  return <DeliveryDetailsContent />
}
